import React from 'react';
import { Rnd } from 'react-rnd';
import Client from '../../lib/Client';
import Strings from '../../lib/Strings';
import Dispatcher from '../../dispatchers/Dispatcher';
import DispatchActions from '../../lib/DispatchActions';

export default class Item extends React.Component {
    constructor(props) {
        super(props);

        this.handleItemChange = this.handleItemChange.bind(this);
    }


    isBox() {
        return this.props.type === Strings.BOX;
    }

    isArrow() {
        return this.props.type.match(/up|right|down|left/);
    }

    isArrowLine() {
        return this.props.card.is_arrow_line;
    }

    /**
     * Handle what happens when a user clicks the edit button on a card.
     */
    handleEditClick = () => {
        Dispatcher.dispatch({
            type: DispatchActions.CARD_EDIT,
            card: this.props.card
        });
    };

    /**
     * Show edit button when a box is rendered
     */
    renderEditButton() {
        if (this.isBox()) {
            return (
                <button onClick={this.handleEditClick} className='boxEdit btn btn-sm btn-outline-primary'>
                    <i className="fa fa-cog"></i>
                </button>
            );
        } else {
            return '';
        }
    }

    /**
     * Show template star if this card is a template
     */
     renderTemplateStar() {
        if (this.props.card.template) {
            return (
                <div className='boxTemplate'>
                    <i className="fa fa-star"></i>
                </div>
            );
        } else {
            return '';
        }
    }

    /**
     * Render card content
     */
    renderContent() {
        const self = this;

        if (this.isBox()) {
            var htmlObject = document.createElement('div');
            htmlObject.innerHTML = this.props.card.display_content;

            $(htmlObject).find('.formula').each(function(index, node) {
                var attributes = {
                    formula:      $(node).data('formula'),
                    default:      $(node).data('default'),
                    max:          Number.parseFloat($(node).data('max')),
                    min:          Number.parseFloat($(node).data('min')),
                    unit:         $(node).data('unit'),
                    delivery:     $(node).data('delivery'),
                    dose:         $(node).data('dose'),
                    dose_range:   $(node).data('dose-range'),
                    is_range:     $(node).data('is-range'),
                    precision:    Number.parseInt($(node).data('precision')),
                    color:        $(node).data('color'),
                    calculated:   $(node).data('calculated'),
                    page:           $(node).data('page'),
                    note:           $(node).data('note'),
                    drug_card_note: $(node).data('drug-card-note'),
                    is_drug_card:   $(node).data('is-drug-card'),
                    is_rx_modal:    $(node).data('is-rx-modal'),
                    hide_meds:      $(node).data('hide-meds'),
                    measure:        $(node).data('measure'),
                    drug_dose_condition: $(node).data('drug-dose-condition'),
                    maximums_only: $(node).data('maximums-only'),
                    rx_note: $(node).data('rx-note'),
                    is_legacy_protocol: $(node).data('is-legacy-protocol'),
                    use_responsoft_default: $(node).data('use-responsoft-default'),
                }
                var result = attributes.min;

                var txt = ""
                if (typeof attributes.drug_dose_condition !== 'undefined') {
                    txt += "<span style='font-size: 10pt'> " + attributes.drug_dose_condition + "</span>"
                }

                txt += self.appendDoseText(attributes);

                // Refactored with ChatGPT into appendDoseText method
                // if (parseInt(attributes.page) > 0) {
                //     if(attributes.is_range) {
                //         // This is a page link and has a dosage range
                //         if (attributes.use_responsoft_default) {
                //             txt += (attributes.calculated) ? "<span style='font-size: 10pt'><a href='"+ parseInt(attributes.page) +".html'><span style='color:"+attributes.color+"; font-weight: bold;  text-decoration: underline; font-size: 10pt;'>"+attributes.default+"</span></a>"+((isNaN(Number.parseFloat(attributes.measure))) ? "" : "("+attributes.measure+" "+attributes.unit+"/mL) ")+" <br><span style='font-weight: bold; padding: 0.5px 6px 0.5px 6px; color: black; background-color: lightgray;'>"+attributes.dose+" - "+attributes.dose_range+" "+attributes.unit+"/kg </span> "+attributes.delivery+"</span>" : "<span style='font-size: 10pt'><a href='"+ parseInt(attributes.page) +".html'><span style='color:"+attributes.color+"; font-weight: bold;  text-decoration: underline; font-size: 10pt;'>"+attributes.default+"</span></a>"+" <br> <span style='font-weight: bold; padding: 0.5px 6px 0.5px 6px; color: black; background-color: lightgray;'>"+attributes.dose+" - "+attributes.dose_range+" "+attributes.unit+" </span>"+attributes.delivery+"</span>";
                //         } else {
                //             txt += (attributes.calculated) ? "<span style='font-size: 10pt'><a href='"+ parseInt(attributes.page) +".html'><span style='color:"+attributes.color+"; font-weight: bold;  text-decoration: underline; font-size: 10pt;'>"+attributes.default+"</span></a>"+((isNaN(Number.parseFloat(attributes.measure))) ? "" : "("+attributes.measure+" "+attributes.unit+"/mL) ")+" <br> <span style='font-weight: bold; padding: 0.5px 6px 0.5px 6px; color: black; background-color: lightgray;'>"+attributes.dose+" - "+attributes.dose_range+" "+attributes.unit+"/kg </span>"+attributes.delivery+"</span>" : "<span style='font-size: 10pt'><a href='"+ parseInt(attributes.page) +".html'><span style='color:"+attributes.color+"; font-weight: bold;  text-decoration: underline; font-size: 10pt;'>"+attributes.default+"</span></a>"+" <br> <span style='font-weight: bold; padding: 0.5px 6px 0.5px 6px; color: black; background-color: lightgray;'>"+attributes.dose+" - "+attributes.dose_range+" "+attributes.unit+" </span>"+attributes.delivery+"</span>";
                //         }
                //     } else {
                //         // This is a page link but not a dosage range
                //         if (attributes.use_responsoft_default) {
                //             txt += (attributes.calculated) ? "<span style='font-size: 10pt'><a href='"+ parseInt(attributes.page) +".html'><span style='color:"+attributes.color+"; font-weight: bold;  text-decoration: underline; font-size: 10pt;'>"+attributes.default+"</span></a>"+((isNaN(Number.parseFloat(attributes.measure))) ? "" : "("+attributes.measure+" "+attributes.unit+"/mL) ")+" <br> <span style='font-weight: bold; padding: 0.5px 6px 0.5px 6px; color: black; background-color: lightgray;'>"+attributes.dose+" "+attributes.unit+"/kg </span>"+attributes.delivery+"</span>" : "<span style='font-size: 10pt'><a href='"+ parseInt(attributes.page) +".html'><span style='color:"+attributes.color+"; font-weight: bold;  text-decoration: underline; font-size: 10pt;'>"+attributes.default+"</span></a>"+" <br> <span style='font-weight: bold; padding: 0.5px 6px 0.5px 6px; color: black; background-color: lightgray;'>"+attributes.dose+" "+attributes.unit+" </span>"+attributes.delivery+"</span>";
                //         } else {
                //             txt += (attributes.calculated) ? "<span style='font-size: 10pt'><a href='"+ parseInt(attributes.page) +".html'><span style='color:"+attributes.color+"; font-weight: bold;  text-decoration: underline; font-size: 10pt;'>"+attributes.default+"</span></a>"+((isNaN(Number.parseFloat(attributes.measure))) ? "" : "("+attributes.measure+" "+attributes.unit+"/mL) ")+" <br> <span style='font-weight: bold; padding: 0.5px 6px 0.5px 6px; color: black; background-color: lightgray;'>"+attributes.dose+" "+attributes.unit+"/kg </span>"+attributes.delivery+"</span>" : "<span style='font-size: 10pt'><a href='"+ parseInt(attributes.page) +".html'><span style='color:"+attributes.color+"; font-weight: bold;  text-decoration: underline; font-size: 10pt;'>"+attributes.default+"</span></a>"+" <br> <span style='font-weight: bold; padding: 0.5px 6px 0.5px 6px; color: black; background-color: lightgray;'>"+attributes.dose+" "+attributes.unit+" </span>"+attributes.delivery+"</span>";
                //         }
                //     }
                // } else {
                //     if (attributes.is_range) {
                //         if (attributes.use_responsoft_default) {
                //             txt += (attributes.calculated) ? "<span style='font-size: 10pt'><span style='color:"+attributes.color+"; font-weight: bold;  text-decoration: underline; font-size: 10pt;'>"+attributes.default+"</span>"+((isNaN(Number.parseFloat(attributes.measure))) ? "" : "("+attributes.measure+" "+attributes.unit+"/mL) ")+" <br> <span style='font-weight: bold; padding: 0.5px 6px 0.5px 6px; color: black; background-color: lightgray;'>"+attributes.dose+ " - "+attributes.dose_range+" "+attributes.unit+"/kg </span> "+attributes.delivery+"</span>" : "<span style='font-size: 10pt'><span style='color:"+attributes.color+"; font-weight: bold;  text-decoration: underline; font-size: 10pt;'>"+attributes.default+"</span>"+" <br> <span style='font-weight: bold; padding: 0.5px 6px 0.5px 6px; color: black; background-color: lightgray;'>"+attributes.dose+ " - "+attributes.dose_range+" "+attributes.unit+" </span>"+attributes.delivery+"</span>"
                //         } else {
                //             txt += (attributes.calculated) ? "<span style='font-size: 10pt'><span style='color:"+attributes.color+"; font-weight: bold;  text-decoration: underline; font-size: 10pt;'>"+attributes.default+"</span>"+((isNaN(Number.parseFloat(attributes.measure))) ? "" : "("+attributes.measure+" "+attributes.unit+"/mL) ")+" <br> <span style='font-weight: bold; padding: 0.5px 6px 0.5px 6px; color: black; background-color: lightgray;'>"+attributes.dose+ " - "+attributes.dose_range+" "+attributes.unit+"/kg </span> "+attributes.delivery+"</span>" : "<span style='font-size: 10pt'><span style='color:"+attributes.color+"; font-weight: bold;  text-decoration: underline; font-size: 10pt;'>"+attributes.default+"</span>"+" <br> <span style='font-weight: bold; padding: 0.5px 6px 0.5px 6px; color: black; background-color: lightgray;'>"+attributes.dose+ " - "+attributes.dose_range+" "+attributes.unit+" </span>"+attributes.delivery+"</span>"
                //         }
                //     } else {
                //         if (use_responsoft_default) {
                //         txt += (attributes.calculated) ? "<span style='font-size: 10pt'><span style='color:"+attributes.color+"; font-weight: bold;  text-decoration: underline; font-size: 10pt;'>"+attributes.default+"</span>"+((isNaN(Number.parseFloat(attributes.measure))) ? "" : "("+attributes.measure+" "+attributes.unit+"/mL) ")+" <br> <span style='font-weight: bold; padding: 0.5px 6px 0.5px 6px; color: black; background-color: lightgray;'>"+attributes.dose+" "+attributes.unit+"/kg </span > "+attributes.delivery+"</span>" : "<span style='font-size: 10pt'><span style='color:"+attributes.color+"; font-weight: bold;  text-decoration: underline; font-size: 10pt;'>"+attributes.default+"</span>"+" <br> <span style='font-weight: bold; padding: 0.5px 6px 0.5px 6px; color: black; background-color: lightgray;'>"+attributes.dose+" "+attributes.unit+" </span>"+attributes.delivery+"</span>"
                //         } else {
                //         txt += (attributes.calculated) ? "<span style='font-size: 10pt'><span style='color:"+attributes.color+"; font-weight: bold;  text-decoration: underline; font-size: 10pt;'>"+attributes.default+"</span>"+((isNaN(Number.parseFloat(attributes.measure))) ? "" : "("+attributes.measure+" "+attributes.unit+"/mL) ")+" <br> <span style='font-weight: bold; padding: 0.5px 6px 0.5px 6px; color: black; background-color: lightgray;'>"+attributes.dose+" "+attributes.unit+"/kg </span> "+attributes.delivery+"</span>" : "<span style='font-size: 10pt'><span style='color:"+attributes.color+"; font-weight: bold;  text-decoration: underline; font-size: 10pt;'>"+attributes.default+"</span>"+" <br> <span style='font-weight: bold; padding: 0.5px 6px 0.5px 6px; color: black; background-color: lightgray;'>"+attributes.dose+" "+attributes.unit+" </span>"+attributes.delivery+"</span>"
                //         }
                //     }
                // }
                var note = attributes.note
                if (typeof note !== 'undefined') {
                    txt = txt + "<span style='font-size: 10pt'> " + note + "</span>"
                }

                if (typeof attributes.maximums_only !== 'undefined') {
                    txt += "<span style='font-size: 10pt'> " + attributes.maximums_only + "</span>"
                }

                $(node).find('.formula-result').html(txt);
            });

            return (
                <div className='cardContent' dangerouslySetInnerHTML={{__html: htmlObject.innerHTML}}></div>
            );
        } else if (this.isArrowLine()) {
          // const icon = `fa fa-caret-${this.props.type.match(/up|right|down|left/)[0]}`;
            const icon = `chart-arrow-${this.props.type.match(/up|right|down|left/)[0]}`;

          return (
              <div key={icon} className={"arrowhead-container"}>
                  <div className={icon} />
              </div>
          );
        } else {
            return '';
        }
    }

    appendDoseText(attributes) {
        const pageNum       = parseInt(attributes.page, 10);
        const hasPage       = pageNum > 0;
        const isRange       = attributes.is_range;
        const isCalc        = attributes.calculated;
        // const useDefault    = attributes.use_responsoft_default;
        const useDefault    = this.props.useDefaultStyles;
        const measureValue  = Number.parseFloat(attributes.measure);
        const hasMeasure    = !isNaN(measureValue);

        // 1) Link wrapper (if any)
        const linkStart = hasPage
            ? `<a href="${pageNum}.html">`
            : "";
        const linkEnd   = hasPage
            ? `</a>`
            : "";

        // 2) “Default” text always styled the same
        const defaultSpan = `
            ${linkStart}
            <span
                style="
                color: ${attributes.color};
                font-weight: bold;
                text-decoration: underline;
                font-size: 10pt;
                ">
                ${attributes.default}
            </span>
            ${linkEnd}
        `.trim();

        // 3) Optional measure
        const measureText = hasMeasure
            ? `(${measureValue} ${attributes.unit}/mL) `
            : "";

        // 4) Dose line, range vs. single
        const doseContent = isRange
            ? `${attributes.dose} - ${attributes.dose_range} ${attributes.unit}/kg`
            : `${attributes.dose} ${attributes.unit}/kg`;

        // 5) Highlight wrapper around dose
        // If there is no "per_mL" (measure) value present and the unit is "mL", make the text white on black
        let highlightedDose = ""
        if (!hasMeasure && attributes.unit === "mL") {
            // If the medication is weight-based, do black on gray
            if (isCalc) {
                highlightedDose = `
                <span
                style="
                    font-weight: bold;
                    padding: 0.5px 6px;
                    color: black;
                    background-color: lightgray;
                ">
                ${doseContent}
                </span>
            `.trim();
            } else {   // If not weight-based, white on black
                highlightedDose = `
                <span
                style="
                    font-weight: bold;
                    padding: 0.5px 6px;
                    color: white;
                    background-color: black;
                ">
                ${doseContent}
                </span>
            `.trim();
            }
        } else {
            highlightedDose = `
                <span
                style="
                    font-weight: bold;
                    padding: 0.5px 6px;
                    color: black;
                    background-color: lightgray;
                ">
                ${doseContent}
                </span>
            `.trim();
        }


        // const blackHighlightedDose = `
        //     <span
        //     style="
        //         font-weight: bold;
        //         padding: 0.5px 6px;
        //         color: white;
        //         background-color: black;
        //     ">
        //     ${doseContent}
        //     </span>
        // `.trim();

        let concentration = ""
        let highlightedConcentration = ""
        let grayHighlightedDose = ""

        var min_calc = 0;
        var max_calc = 0;
        var calulated_decimal_places = 0;

        if (hasMeasure && measureValue > 0) {

            min_calc = attributes.dose / attributes.measure;
            
            if (min_calc > 10) {
                calulated_decimal_places = 0;
              } else if (min_calc > 1) {
                calulated_decimal_places = 1;
              } else {
                calulated_decimal_places = 2;
              }

              min_calc = min_calc.toLocaleString("en-US", {
                maximumFractionDigits: calulated_decimal_places,
              });

            if (isRange) {
                max_calc = attributes.dose_range / attributes.measure;

                if (max_calc > 10) {
                    calulated_decimal_places = 0;
                  } else if (max_calc > 1) {
                    calulated_decimal_places = 1;
                  } else {
                    calulated_decimal_places = 2;
                  }
                  
                  max_calc = max_calc.toLocaleString("en-US", {
                    maximumFractionDigits: calulated_decimal_places,
                  });

                // concentration = `${(attributes.dose / attributes.measure).toFixed(0)} - ${(attributes.dose_range / attributes.measure).toFixed(0)} ${attributes.unit}`
                concentration = `${min_calc} - ${max_calc} mL`
            } else {
                // concentration = `${(attributes.dose / attributes.measure).toFixed(0)} ${attributes.unit}`
                concentration = `${min_calc} mL`
            }
            
            highlightedConcentration = `
            <span
            style="
                font-weight: bold;
                padding: 0.5px 6px;
                color: white;
                background-color: black;
            ">
            ${(concentration)}
            </span>`.trim();

            grayHighlightedDose = `
                <span
                style="
                    font-weight: bold;
                    padding: 0.5px 6px;
                    color: blue;
                    background-color: lightgray;
                ">
                ${doseContent}
                </span>
            `.trim();
        }

        // 6) Suffix (delivery)
        const deliveryText = ` ${attributes.delivery}`;

        // 7) Build the inner content for each branch
        let inner;

        if (hasMeasure && measureValue > 0 && !isCalc) {
            if (useDefault) {
                // This is what was before swapping the black background and the gray background content
                // inner = `${defaultSpan}<br>${blackHighlightedDose.replace('/kg', '')}${highlightedConcentration}&nbsp;${deliveryText}`
                inner = `${defaultSpan}${measureText}<br>${highlightedConcentration}${grayHighlightedDose.replace('/kg', '')}&nbsp;${deliveryText}`
            } else {
                // This is what was before swapping the black background and the gray background content
                // inner = `${defaultSpan}<br>${doseContent.replace('/kg', '')}${concentration}&nbsp;${deliveryText}`
                inner = `${defaultSpan}${measureText}<br>${concentration}&nbsp;<span style="font-weight: bold">${doseContent.replace('/kg', '')}</span>&nbsp;${deliveryText}`
            }
        } else if (useDefault) {
            // Responsoft‐default styling block
            inner = isCalc
            ? `${defaultSpan}${measureText}<br>${highlightedDose}&nbsp;${deliveryText}`
            : `${defaultSpan}<br>${highlightedDose.replace('/kg', '')}&nbsp;${deliveryText}`; // if wanting to do highlighted, non-weight-based doses
            // : `${defaultSpan}<br>${doseContent.replace('/kg', '')}${deliveryText}`; // un-hilighted non-weight-based doses
        } else {
            inner = isCalc
            ? `${defaultSpan}${measureText}<br>${doseContent}&nbsp;${deliveryText}`
            : `${defaultSpan}<br>${doseContent.replace('/kg', '')}&nbsp;${deliveryText}`; // if wanting to do highlighted, non-weight-based doses
            // : `${defaultSpan}<br>${doseContent.replace('/kg', '')}${deliveryText}`; // un-hilighted non-weight-based doses
        }

        // 8) Wrap everything in the outer font‐size span
        const fullSpan = `<span style="font-size: 10pt">${inner}</span>`;

        // Append to your txt
        return fullSpan;
    }

    /**
     * Send a network request to our API, saving the new version of a card.
     */
    saveCard(newCard) {
        if (newCard.x === this.props.card.x && newCard.y === this.props.card.y && newCard.height === this.props.card.height && newCard.width === this.props.card.width) {
            return;
        }

        Client.saveCard(newCard);
    }

    handleClick = () => {
        if (this.props.card.box_line_type === Strings.BOX) {
            return;
        }

        Dispatcher.dispatch({
            type: DispatchActions.CARD_EDIT,
            card: this.props.card
        });
    };

    /**
     * Figure out what the item x should be. For some reason
     * below we have to divide the x values by 2 when
     * the page loads. However, when adding new lines we
     * can just use the normal value if it's a 'new' line.
     */
    itemX() {
        if (this.props.card.new) {
            return this.props.card.x;
        } else {
            return this.props.card.x;
            // return this.props.card.x / 2;
        }
    }

    calculateSnap() {
        return [20,20];
    }


    handleItemChange(newState) {
        this.props.card.cardChangeHandler({ ...this.props.card, ...newState });
    }

    render() {
        const active = this.props.active === this.props.card.id ? 'active' : '';
        return (
            <Rnd
                className={`${this.props.type} ${active} ${this.props.className} ${this.props.useDefaultStyles ? 'medication-extra-line-height' : ''}`}
                onResizeStop={(e, direction, ref, delta, position) => {
                    this.handleItemChange({
                        width: ref.style.width,
                        height: ref.style.height,
                        x: position.x,
                        y: position.y
                    });
                }}
                onDragStop={(e, d) => {
                    this.handleItemChange({
                        x: this.props.card.nudged ? d.x : d.lastX,
                        y: this.props.card.nudged ? d.y : d.lastY
                    });
                }}
                style={this.props.style}
                enableResizing={this.props.resizing}
                default={{
                    x: this.itemX(),
                    y: this.props.card.y,
                    width: this.props.card.width,
                    height: this.props.card.height
                }}
                bounds='parent'
                onClick={this.handleClick}
                resizeGrid={this.calculateSnap()}
                dragGrid={this.calculateSnap()}
            >

                {this.renderEditButton()}
                {this.renderTemplateStar()}
                {this.renderContent()}
            </Rnd>
        );
    }
}
